export function setLocalStorageVal(key, val) {
  if (!key || !val) return;

  window.localStorage.setItem(key, JSON.stringify(val));
}

export function getStorageValByKey(key) {
  if (!key) return null;
  const res = window.localStorage.getItem(key);

  return !res ? res : JSON.parse(res);
}

export const STORAGE_KEY = {
  token: "token",
  nickName: "nickName",
  permissionList: "permissionList",
  account: "account",
  passwod: "password",
  userNo: "userNo",
};

// 设置多个键值对
export const setLocalStorageMultipleItems = (items) => {
  try {
    Object.entries(items).forEach(([key, value]) => {
      setLocalStorageVal(key, value);
    });
  } catch (error) {
    console.error("设置多个键值对时出错:", error);
  }
};
